import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { login } from '../store/authSlice'
import { useToastWithRedux } from '../hooks/useToastWithRedux'

const Login = () => {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm()
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { loading, error } = useSelector((state) => state.auth)
	const { handleLoginResult } = useToastWithRedux()
	
	// 密码显示状态
	const [showPassword, setShowPassword] = useState(false)

	const onSubmit = async (data) => {
		try {
			const result = await dispatch(login(data))
			handleLoginResult(result)
			
			if (result.meta?.requestStatus === 'fulfilled' && result.payload?.token) {
				// 确保有 token 后再跳转，并且使用正确的路由路径
				navigate('/website-config', { replace: true })
			}
		} catch (err) {
			// 错误已经在 slice 中处理
			console.error('Login failed:', err)
		}
	}

	// 切换密码显示状态
	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword)
	}

	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
			<div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md">
				<div className="text-center">
					<h2 className="text-2xl font-bold text-gray-900">Hello! let's get started</h2>
					<p className="mt-2 text-sm text-gray-600">Sign in to continue.</p>
				</div>
				
				<form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
					<div className="space-y-4">
						<div>
							<input
								id="username"
								type="text"
								{...register('username', { required: 'Please enter your username' })}
								className="appearance-none block w-full px-3 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
								placeholder="Username"
							/>
							{errors.username && (
								<p className="mt-2 text-sm text-red-600">
									{errors.username.message}
								</p>
							)}
						</div>
						
						<div className="relative">
							<input
								id="password"
								type={showPassword ? 'text' : 'password'}
								{...register('password', { required: 'Please enter your password' })}
								className="appearance-none block w-full px-3 py-3 pr-10 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
								placeholder="Password"
							/>
							<button
								type="button"
								onClick={togglePasswordVisibility}
								className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 focus:outline-none"
							>
								{showPassword ? (
									<svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
									</svg>
								) : (
									<svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
									</svg>
								)}
							</button>
							{errors.password && (
								<p className="mt-2 text-sm text-red-600">
									{errors.password.message}
								</p>
							)}
						</div>
					</div>

					<div className="flex items-center justify-between">
						<div className="flex items-center">
							<input
								id="remember-me"
								name="remember-me"
								type="checkbox"
								className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
							/>
							<label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
								Keep me signed in
							</label>
						</div>

						<div className="text-sm">
							<a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
								Forgot password?
							</a>
						</div>
					</div>

					<div>
						<button
							type="submit"
							disabled={loading}
							className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brand-primary hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-indigo-400"
						>
							{loading ? 'Signing in...' : 'SIGN IN'}
						</button>
					</div>
				</form>

				<div className="mt-6 text-center">
					<p className="text-sm text-gray-600">
						Don't have an account?{' '}
						<a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
							Create
						</a>
					</p>
				</div>
			</div>
		</div>
	)
}

export default Login 